<template>
  <form-group
    v-bind="$attrs"
  >
    <v-row
      justify="start"
      align="center"
    >
      <v-col cols="6">
        <input-radio
          id="input:indSomarTaxasBonus"
          v-model="payload.indSomarTaxasBonus"
          label="Taxa bônus:"
          :options="indSomarTaxasBonusOptions"
          row
        />
      </v-col>
    </v-row>
    <v-row class="mb-3 mt-6">
      <form-group
        title="Valores"
        class="ma-0 pa-0"
      >
        <v-divider />
      </form-group>
    </v-row>
    <form-group class="ma-0 pa-0">
      <v-tabs
        v-model="tabs"
      >
        <v-tab
          v-for="(tab, id) in typeValues"
          :key="`tab_${tab.value + id}`"
        >
          {{ tab.text }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tabs"
      >
        <v-tab-item
          v-for="(tab, id) in typeValues"
          :key="`tab_item_${tab.value + id}`"
        >
          <form-group>
            <v-row
              v-for="(item, idx) in getFaultValues(tab.value)"
              :key="`valor_${idx}`"
            >
              <v-col cols="10">
                <v-row>
                  <v-col cols="3">
                    <v-checkbox
                      id="input:isValorTardio"
                      v-model="getFaultValues(tab.value)[idx].isValorTardio"
                      label="Valor tardio"
                    />
                  </v-col>
                  <v-col cols="3">
                    <input-select
                      id="input:tipoComissaoTemplate"
                      v-model="getFaultValues(tab.value)[idx].tipoComissaoTemplate"
                      label="Tipo da comissão"
                      :items="tipoComissaoTemplateOptions"
                    />
                  </v-col>
                  <v-col cols="3">
                    <input-select
                      id="input:tipoValorTemplate"
                      v-model="getFaultValues(tab.value)[idx].tipoValorTemplate"
                      label="Tipo do valor"
                      :items="tipoValorTemplateOptions"
                    />
                  </v-col>
                  <v-col cols="3">
                    <input-money
                      v-if="getFaultValues(tab.value)[idx].tipoValorTemplate === 'FIXO'"
                      id="input:valor"
                      v-model="getFaultValues(tab.value)[idx].valor"
                      label="Valor"
                    />
                    <input-percentage
                      v-else
                      id="input:valor"
                      v-model="getFaultValues(tab.value)[idx].valor"
                      label="Valor"
                      :decimals="1"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2">
                <v-row
                  justify="start"
                  align="center"
                >
                  <v-btn
                    v-if="displayRemove(tab.value, idx)"
                    :id="`remove_${idx}`"
                    icon
                    color="primary"
                    width="50"
                    height="50"
                    @click="removeItem(tab.value, idx)"
                  >
                    <v-icon size="45">
                      mdi-minus-circle
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="isLastItem(tab.value, idx)"
                    :id="`add_${idx}`"
                    icon
                    color="#2ABD49"
                    width="50"
                    height="50"
                    @click="addItem(tab.value)"
                  >
                    <v-icon size="45">
                      mdi-plus-circle
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </form-group>
        </v-tab-item>
      </v-tabs-items>
    </form-group>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import CommisionTypes from '@/app/arch/enums/CommisionTypes';
import ValueTypes from '@/app/arch/enums/ValueTypes';
import TemplateProductStoreTypeValues from 'Arch/enums/TemplateProductStoreTypeValues';

export const itemListaValor = {
  valor: '',
  tipoValorTemplate: '',
  tipoComissaoTemplate: '',
  isValorTardio: false,
};

export default {
  name: 'ProductTemplateContentValues',
  components: { FormGroup },
  mixins: [RulesMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          indSomarTaxasBonus: '',
          valores: {
            cartaoDebito: [{ ...itemListaValor }],
            cartaoCredito: [{ ...itemListaValor }],
            cartaoCreditoParcelado: [{ ...itemListaValor }],
            pix: [{ ...itemListaValor }],
            prePago: [{ ...itemListaValor }],
            posPago: [{ ...itemListaValor }],
          },
        };
      },
    },
  },
  data: () => ({
    tipoComissaoTemplateOptions: CommisionTypes,
    tipoValorTemplateOptions: ValueTypes,
    tabs: null,
    indSomarTaxasBonusOptions: [
      {
        value: true,
        label: 'Somar',
      },
      {
        value: false,
        label: 'Não somar',
        color: 'primary',
      },
    ],
    typeValues: TemplateProductStoreTypeValues.filter(
      (item) => item.value !== 'posPago',
    ),
  }),
  computed: {
    payload() {
      return this.value;
    },
    displayRemove() {
      return (item, idx) => this.getFaultValues(item).length > 1 && idx >= 0;
    },
    isLastItem() {
      return (item, pos) => pos === (this.getFaultValues(item).length - 1);
    },
    getFaultValues() {
      return (item) => {
        const faultItems = this.payload.valores[item];
        if (faultItems.length >= 1) {
          return this.payload.valores[item];
        }
        this.payload.valores[item].push({ ...itemListaValor });
        return this.payload.valores[item];
      };
    },
  },
  methods: {
    removeItem(item, idx) {
      this.getFaultValues(item).splice(idx, 1);
    },
    addItem(item) {
      this.getFaultValues(item).push({ ...itemListaValor });
    },
  },
};
</script>
